var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.663 13.995V12.6622C10.663 11.9552 10.3822 11.2772 9.88226 10.7772C9.38234 10.2773 8.7043 9.99646 7.99731 9.99646H3.99873C3.29173 9.99646 2.6137 10.2773 2.11378 10.7772C1.61386 11.2772 1.33301 11.9552 1.33301 12.6622V13.995",
    stroke: "#155DFC",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99775 7.33074C7.46999 7.33074 8.66347 6.13725 8.66347 4.66502C8.66347 3.19278 7.46999 1.9993 5.99775 1.9993C4.52551 1.9993 3.33203 3.19278 3.33203 4.66502C3.33203 6.13725 4.52551 7.33074 5.99775 7.33074Z",
    stroke: "#155DFC",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6614 13.995V12.6622C14.661 12.0715 14.4644 11.4978 14.1025 11.031C13.7406 10.5642 13.234 10.2308 12.6621 10.0831",
    stroke: "#155DFC",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6631 2.08594C11.2365 2.23275 11.7447 2.56623 12.1077 3.03381C12.4706 3.50138 12.6676 4.07645 12.6676 4.66835C12.6676 5.26026 12.4706 5.83533 12.1077 6.3029C11.7447 6.77047 11.2365 7.10395 10.6631 7.25077",
    stroke: "#155DFC",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9943,
    height: 15.9943,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon15);
export default __webpack_public_path__ + "static/media/icon15.b34a359473bd588ea35c85d6515c9251.svg";
export { ForwardRef as ReactComponent };